import C from '../../../constants/accounting/payable/historyPreviewSupplierDomestic';
import accountingServices from "../../../services/accountingServices";

export const activeScreenPreviewDomestic = () => dispatch => {
    dispatch({type: C.ACTIVE_SCREEN_STATUS, payload: true})
}

export const getInvoiceSupplierDomesticView = (id) => dispatch => {
    accountingServices.getInvoiceSupplierDomestic(id).then(res => {
        if(res.success) {
            dispatch({type: C.CHANGE_INVOICE_DETAIL, payload: res.data})
        }
    })
}

export const resetData = () => dispatch => {
    dispatch({type: C.RESET_DATA})
}